import React from 'react';

function CategoryIcon({ className, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.10033 2.46001L4.62033 6.51335C4.34699 6.95335 4.66699 7.52668 5.18699 7.52668H10.1403C10.6603 7.52668 10.9803 6.95335 10.707 6.51335L8.23366 2.46001C7.97366 2.03335 7.36033 2.03335 7.10033 2.46001ZM11.3337 8.86001C10.2619 8.86001 9.27148 9.43181 8.73558 10.36C8.19968 11.2882 8.19968 12.4318 8.73558 13.36C9.27148 14.2882 10.2619 14.86 11.3337 14.86C12.4055 14.86 13.3958 14.2882 13.9317 13.36C14.4676 12.4318 14.4676 11.2882 13.9317 10.36C13.3958 9.43181 12.4055 8.86001 11.3337 8.86001ZM6.33366 14.5267H2.33366C1.96699 14.5267 1.66699 14.2267 1.66699 13.86V9.86001C1.66699 9.49335 1.96699 9.19335 2.33366 9.19335H6.33366C6.70033 9.19335 7.00033 9.49335 7.00033 9.86001V13.86C7.00033 14.2267 6.70033 14.5267 6.33366 14.5267Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default CategoryIcon;
